<h1 class="margin-left">Störungsmanagement</h1>
<hex-label-item class="report-button" *ngIf="!showForm" [label]="'Störungsmeldung anlegen'" (click)="showForm = true">
</hex-label-item>

<app-report-malfunction-screen *ngIf="showForm" [editForm]="true" [adminView]="true"
    (showFormEmitter)="showForm = false">
</app-report-malfunction-screen>

<app-malfunction-overview *ngIf="showOverview" [adminView]="true"></app-malfunction-overview>